import { render } from "./index.vue?vue&type=template&id=f36366be&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=tsx"
export * from "./index.vue?vue&type=script&lang=tsx"

import "./index.vue?vue&type=style&index=0&id=f36366be&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f36366be"]])

export default __exports__